var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.72727 10.5681V9.47723C9.72727 8.27224 8.75044 7.29541 7.54546 7.29541H3.18182C1.97683 7.29541 1 8.27224 1 9.47723V10.5681",
    stroke: "#141E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3637 5.11364C6.56869 5.11364 7.54552 4.1368 7.54552 2.93182C7.54552 1.72683 6.56869 0.75 5.3637 0.75C4.15872 0.75 3.18188 1.72683 3.18188 2.93182C3.18188 4.1368 4.15872 5.11364 5.3637 5.11364Z",
    stroke: "#141E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 10.5683V9.47736C12.9994 8.48306 12.3265 7.61503 11.3638 7.36646",
    stroke: "#141E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18188 0.820801C10.1473 1.06798 10.8225 1.93789 10.8225 2.93444C10.8225 3.93099 10.1473 4.80089 9.18188 5.04807",
    stroke: "#141E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamSmall);
export default __webpack_public_path__ + "static/media/team-small.c17a2c1a.svg";
export { ForwardRef as ReactComponent };